import { Component } from '@angular/core';
import { NavigationItem } from '@next/core-lib/navigation';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  navigationItems: NavigationItem[] = [
    {
      relativeUrl: '/cropsettings',
      label: 'cropSettings',
      icon: 'flaky',
    },
    {
      relativeUrl: '/activeingredientsettings',
      label: 'activeIngredientSettings',
      icon: 'control_point_duplicate',
    },
  ];
}
